{
  "EntityHoverCard": {
    "cantLoad": "无法加载详情。",
    "openInSidebar": "在侧栏中打开",
    "openFullPage": "打开完整页面",
    "more": "还有 {{count}} 个"
  },
  "ConfirmPopover": {
    "cancel": "取消"
  },
  "RowList": {
    "reorderInstructions": "要重新排序，请按空格键或回车键拿起此{{item}}，用上下方向键移动，再按空格键或回车键放下，或按 Esc 取消。",
    "pickedUp": "已拿起{{item}}，位置 {{position}}/{{count}}。",
    "notOver": "不在列表中的任何位置上。",
    "moving": "移动到位置 {{position}}/{{count}}。",
    "droppedUnchanged": "已放下。顺序未改变。",
    "dropped": "已放下到位置 {{position}}/{{count}}。",
    "cancelled": "已取消。{{item}}仍在位置 {{position}}/{{count}}。",
    "reorder": "重新排序 {{label}}",
    "remove": "删除 {{label}}"
  },
  "GlobalCustomFieldHint": {
    "ariaLabel": "全局字段",
    "tooltip": "此字段为全局字段。更改将在该资源所分配的所有工作区中可见。"
  },
  "FormSaveButton": {
    "save": "保存"
  },
  "StickyFormActionsBar": {
    "toolbarLabel": "表单操作",
    "hotkeyHintBefore": "按",
    "hotkeyHintAfter": "保存更改",
    "cancel": "取消"
  },
  "DialogErrorFooter": {
    "error": "错误"
  },
  "FormDialogContent": {
    "save": "保存"
  },
  "ArchiveConfirmationDialog": {
    "archiveTitle": "要归档{{entityName}}吗？",
    "unarchiveTitle": "要恢复{{entityName}}吗？",
    "archiveDescription": "确定要归档此{{entityName}}吗？不会丢失任何数据。",
    "unarchiveDescription": "确定要恢复此{{entityName}}吗？",
    "archiveConfirm": "归档",
    "unarchiveConfirm": "恢复",
    "cancel": "取消",
    "confirmInProgress": "{{label}}…",
    "confirmRetry": "{{label}}（重试）",
    "srDescriptionArchive": "归档{{entityName}}的确认对话框。",
    "srDescriptionUnarchive": "恢复{{entityName}}的确认对话框。"
  },
  "CurrencyCombobox": {
    "placeholder": "搜索货币…",
    "empty": "没有匹配的货币"
  },
  "TimezoneCombobox": {
    "placeholder": "搜索时区…",
    "empty": "没有匹配的时区"
  },
  "ImageUploadField": {
    "hint": "将图片拖放到此处或点击方块。",
    "formats": "JPG 或 PNG，最大 10 MB",
    "upload": "上传",
    "change": "更换",
    "uploading": "上传中…",
    "paste": "粘贴",
    "remove": "移除",
    "uploadError": "图片上传失败",
    "pasteEmpty": "剪贴板中没有图片",
    "pasteFailed": "无法读取剪贴板。请选中方块后使用粘贴快捷键。"
  },
  "ImageCollectionUploadField": {
    "listLabel": "已上传的文件",
    "emptyTitle": "将文件拖到此处，或点击选择",
    "emptyTitleSingle": "将文件拖到此处，或点击选择",
    "formats": "{{formats}}，最大 {{size}} · 字段获得焦点时可用 ⌘V 粘贴",
    "formatImages": "图片",
    "formatVideos": "视频",
    "formatPdf": "PDF 文档",
    "add": "添加",
    "browse": "选择文件",
    "replace": "替换",
    "paste": "粘贴",
    "reorderHint": "{{count}} 个文件 · 拖动以重新排序",
    "dropToAdd": "松开以添加",
    "reorder": "重新排序 {{name}}",
    "remove": "删除 {{name}}",
    "uploadFailed": "上传失败",
    "retry": "重试",
    "dismiss": "关闭 {{name}}",
    "rejected": "无法在此上传 {{name}}",
    "tooLarge": "{{name}} 超过 {{size}}",
    "pasteEmpty": "剪贴板中没有图片",
    "pasteFailed": "无法读取剪贴板。请聚焦该字段并使用粘贴快捷键。",
    "open": "打开文件",
    "removeShort": "删除",
    "noFiles": "暂无文件"
  },
  "FinancialDocumentDialog": {
    "addInvoice": "添加发票",
    "addReceipt": "添加收据",
    "editInvoice": "编辑发票",
    "editReceipt": "编辑收据",
    "create": "创建",
    "invoice": "发票",
    "invoices": "发票",
    "receipt": "收据",
    "receipts": "收据",
    "expense": "费用",
    "expensePlaceholder": "选择费用",
    "reference": "参考",
    "referencePlaceholder": "输入参考",
    "amount": "金额",
    "status": "状态",
    "statusPlaceholder": "选择状态",
    "file": "文件",
    "fileDescription": "支持 PDF 和图片格式",
    "upload": "上传",
    "attachedReceipt": "已附收据",
    "documentCount": "{{count}} 个文档",
    "unsavedChanges": "财务文档表单中有未保存的更改。",
    "download": "下载",
    "openInNewTab": "在新标签页中打开",
    "untitled": "无标题",
    "noFileAttached": "未附加文件",
    "documentSaved": "文档已保存",
    "documentDeleted": "文档已删除",
    "documentSaveFailed": "保存文档失败",
    "documentDeleteFailed": "删除文档失败",
    "allReconciledTooltip": "所有文档已核对：实际等于已承诺，且每个文档（不包括待批准的）状态为已付款或已批准。",
    "underCommittedTooltip": "低于已承诺：实际支出少于已承诺金额。",
    "overCommittedTooltip": "超过已承诺：实际支出超过已承诺金额。"
  },
  "UnsavedChangesDialog": {
    "title": "未保存的更改",
    "description": "您有未保存的更改。确定要离开吗？您的更改将会丢失。",
    "cancel": "继续编辑",
    "confirm": "放弃更改",
    "beforeUnload": "您有未保存的更改。确定要离开吗？",
    "draftDescription": "您对“{{title}}”的更改尚未保存，将会丢失。"
  },
  "EnumFilterWidget": {
    "operator": {
      "matchAny": "是任意一个",
      "matchAll": "是全部",
      "matchNone": "不是任意一个",
      "empty": "为空",
      "notEmpty": "不为空"
    },
    "searchPlaceholder": "搜索选项…",
    "emptyValue": "请选择",
    "valueNotRequired": "无需选择值"
  },
  "DateFilterCustomDialog": {
    "title": "自定义日期或时间范围",
    "enterHumanDate": "输入自然语言日期",
    "humanPlaceholder": "例如：next 7 days、tomorrow、2025-01-14、Jan 20 - Jan 27",
    "examples": "示例：“next 7 days”、“tomorrow”、“Jan 20 - Jan 27”",
    "or": "或",
    "setSpecificDate": "设置具体日期",
    "single": "单日",
    "range": "范围",
    "clear": "清除",
    "willApply": "将应用：",
    "apply": "应用"
  },
  "DateFilterWidget": {
    "operator": {
      "between": "介于",
      "after": "之后",
      "before": "之前",
      "equal": "当日"
    },
    "emptyValue": "请选择日期",
    "apply": "应用",
    "cancel": "取消"
  },
  "BooleanFilterWidget": {
    "operator": {
      "is": "为",
      "isNot": "不为"
    }
  },
  "NumberFilterWidget": {
    "title": "设置数字",
    "operator": {
      "equal": "等于",
      "notEqual": "不等于",
      "greaterThan": "大于",
      "lessThan": "小于",
      "between": "介于"
    },
    "to": "到",
    "apply": "应用",
    "cancel": "取消"
  },
  "StringFilterWidget": {
    "operator": {
      "equals": "为",
      "contains": "包含",
      "notContains": "不包含"
    },
    "placeholder": "请输入内容",
    "emptyValue": "请输入内容",
    "apply": "应用",
    "cancel": "取消",
    "suggestionsIdleHint": "开始输入以搜索，或从下方选择最近使用的位置。",
    "suggestionsEmpty": "没有匹配的位置，请尝试其他关键词。",
    "recentPlacesHeading": "最近",
    "useTypedText": "使用“{{query}}”"
  },
  "FilterWidgetAddControl": {
    "manageFilters": "管理筛选器",
    "searchPlaceholder": "搜索筛选器…",
    "emptySearch": "没有匹配的筛选器"
  },
  "ArchivedTabs": {
    "all": "全部",
    "archived": "已归档"
  },
  "ActiveTabs": {
    "active": "启用",
    "inactive": "停用"
  },
  "SortableEntityTable": {
    "failedToLoadData": "加载数据失败",
    "selectAllItems": "全选",
    "selectItem": "选择 {{key}}",
    "actionsSrOnly": "操作",
    "validationIssueSrOnly": "校验问题",
    "collapseRow": "折叠行",
    "expandRow": "展开行",
    "expandAllRows": "展开所有行",
    "collapseAllRows": "折叠所有行",
    "dragToReorder": "重新排序行",
    "locked": "已锁定",
    "reorderSrOnly": "重新排序",
    "clearSortToReorder": "清除排序以重新排序"
  },
  "MediaCarousel": {
    "openMedia": "打开媒体"
  },
  "PinViewer": {
    "empty": "没有可显示的 Pin",
    "untitled": "未命名 Pin",
    "listLabel": "Pin"
  },
  "MediaLoadStateOverlays": {
    "imageUnavailable": "图片不可用",
    "videoUnavailable": "视频不可用"
  },
  "EntityListToolbar": {
    "searchPlaceholder": "搜索...",
    "resourcesSearchPlaceholder": "搜索资源...",
    "clearAllFilters": "清除所有筛选器"
  },
  "EntityGridItem": {
    "noName": "无名称"
  },
  "CoreFields": {
    "status": "状态",
    "production_date": "制作日期",
    "code": "代码",
    "archived": "已归档",
    "userId": "所有者",
    "productionTypeId": "制作类型",
    "resource_type_id": "类型",
    "organisation_id": "组织",
    "represented_by_id": "代理",
    "role": "角色",
    "tags": "标签",
    "groups": "分组",
    "emails": "邮箱",
    "phone_numbers": "电话",
    "websites": "网站",
    "socials": "社交媒体",
    "locations": "地点",
    "icon": "图标",
    "color": "颜色",
    "title": "标题",
    "description": "描述",
    "budget_amount": "预算金额",
    "createdAt": "创建时间",
    "updatedAt": "更新时间"
  },
  "CalloutSpecificFields": {
    "published": "已发布",
    "archived": "已归档",
    "slug": "URL 别名"
  },
  "ResourceSpecificFields": {
    "groupName": "资源特定",
    "contact_type": "资源类型",
    "emails": "电子邮件",
    "phones": "电话",
    "websites": "网站",
    "socials": "社交媒体",
    "user_id": "所有者",
    "enterprise_workspaces": "工作区",
    "enterprise_workspaces_workspaces": "指定工作区",
    "enterprise_workspaces_hidden": "隐藏",
    "enterprise_workspaces_global": "全局"
  },
  "ContactTypes": {
    "INDIVIDUAL": "个人",
    "ORGANIZATION": "组织",
    "LOCATION": "地点",
    "ITEM": "项目",
    "TALENT": "人才",
    "AGENT": "代理"
  },
  "CustomFields": {
    "today": "今天"
  },
  "EntityTypes": {
    "production": "制作",
    "booking": "预订",
    "resource": "资源",
    "expense": "费用"
  },
  "FilterGroups": {
    "coreFields": "核心字段",
    "customFields": "自定义字段"
  },
  "ReconciliationsTable": {
    "collapseAllDocuments": "全部折叠文档",
    "expandAllDocuments": "全部展开文档",
    "lineType": "行类型",
    "updatedAt": "更新时间",
    "vendorTooltipBooking": "预订",
    "vendorTooltipBudgetExpense": "制作预算费用",
    "expenseDetailsPopover": {
      "title": "费用详情",
      "vendor": "供应商",
      "category": "类别",
      "committed": "已承诺",
      "actual": "实际",
      "receipts": "收据",
      "edit": "编辑"
    }
  },
  "ReconciliationFilters": {
    "invoice_status": {
      "AWAITING_APPROVAL": "待批准",
      "APPROVED": "已批准",
      "PAID": "已支付",
      "DECLINED": "已拒绝"
    }
  },
  "EntityListViewSwitch": {
    "gridView": "网格视图",
    "listView": "列表视图"
  },
  "EntityListSortSelect": {
    "sort": "排序",
    "placeholder": "排序",
    "noSort": "不排序",
    "sortAsc": "(A→Z)",
    "sortDesc": "(Z→A)"
  },
  "EntityGridSelectionToolbar": {
    "selectAllItems": "全选"
  },
  "EntityGridListItem": {
    "selectItem": "选择 {{key}}",
    "deselectItem": "取消选择 {{key}}"
  },
  "EntityListRow": {
    "validationFailed": "数据校验失败",
    "validationDetailsTitle": "校验错误详情",
    "tryDisplayAnyway": "仍尝试显示",
    "hideUnsafePreview": "隐藏预览",
    "renderCrashed": "无法渲染此项",
    "renderTryAgain": "重试"
  },
  "EntityGridTileSizeSlider": {
    "size": "大小",
    "thumbnailSizeAria": "缩略图大小"
  },
  "SortableEntityGrid": {
    "itemsAriaLabel": "项目"
  },
  "EntityEmptyState": {
    "nothingHereYet": "这里还没有内容。",
    "noResultsMatchFilters": "没有符合当前筛选条件的结果。",
    "clearFilters": "清除筛选",
    "pageOutOfRangeTitle": "该页不存在",
    "pageOutOfRangeMessage": "当前页没有结果。请返回最后一页。",
    "goToLastPage": "前往最后一页"
  },
  "TableColumnManagerPopover": {
    "title": "自定义列",
    "shown": "已显示",
    "available": "可用",
    "searchPlaceholder": "搜索字段...",
    "reset": "重置",
    "apply": "应用",
    "cancel": "取消",
    "fixed": "固定",
    "noShownResults": "没有匹配的可见字段",
    "noAvailableResults": "没有匹配的可用字段",
    "triggerAriaLabel": "管理列",
    "availableFieldsCount": "{{count}} 个字段",
    "availableFieldsCount_other": "{{count}} 个字段",
    "dragHandle": "拖动 {{field}}",
    "changed": "已更改",
    "showField": "显示 {{field}}",
    "hideField": "隐藏 {{field}}"
  },
  "TransferToWorkspaceDialog": {
    "fieldCurrentWorkspace": "当前工作区",
    "selectWorkspace": "选择工作区",
    "sameWorkspace": "请选择与当前不同的工作区",
    "save": "转移",
    "transferFailed": "转移失败，请重试。"
  },
  "TransferToTeamDialog": {
    "fieldCurrentWorkspace": "当前工作区",
    "selectWorkspace": "选择工作区",
    "selectTeam": "选择团队",
    "save": "转移",
    "transferFailed": "转移失败，请重试。"
  },
  "CustomFieldAddFlow": {
    "addTitle": "添加自定义字段",
    "createTitle": "创建新字段",
    "searchPlaceholder": "搜索字段或输入以创建…",
    "createNamed": "创建「{{name}}」",
    "addAsNewHint": "作为新的自定义字段添加",
    "selectFieldsToAdd": "选择要添加的字段",
    "fieldsSection": "字段",
    "groupsSection": "字段组",
    "groupFieldCount_other": "{{count}} 个字段",
    "groupMultiple": "可多次添加",
    "alreadyAdded": "已添加",
    "currentlyAssigned": "当前已分配（{{count}}）",
    "noCatalog": "暂无可用自定义字段。请在下方创建。",
    "noFieldsAvailable": "没有可用字段",
    "noFieldsAvailable_search": "没有与搜索匹配的字段",
    "saveFields": "保存字段",
    "cancel": "取消",
    "createAndAssign": "创建并分配",
    "stageDescription_search": "搜索现有自定义字段或创建新字段。",
    "stageDescription_create": "配置新的自定义字段。",
    "back": "返回",
    "nameValidation_required": "必须填写名称。",
    "nameValidation_minLength": "名称至少需要 3 个字符。",
    "nameValidation_duplicate": "已存在同名的自定义字段。"
  },
  "IconPicker": {
    "placeholder": "选择图标"
  },
  "ColorPicker": {
    "placeholder": "选择颜色",
    "hexInputLabel": "十六进制颜色",
    "hexInputPlaceholder": "#000000"
  },
  "ColorIconPicker": {
    "placeholder": "选择图标和颜色"
  },
  "ResourceTypeIconPicker": {
    "placeholder": "选择图标"
  },
  "FullPageErrorLog": {
    "copy": "复制",
    "copied": "已复制"
  },
  "common": {},
  "SchemaForm": {
    "contact": {
      "row": {
        "EMAIL": "邮箱 {{index}}",
        "PHONE": "电话 {{index}}",
        "SOCIAL": "社交账号 {{index}}",
        "WEBSITE": "网站 {{index}}"
      },
      "add": {
        "EMAIL": "添加邮箱",
        "PHONE": "添加电话",
        "SOCIAL": "添加社交账号",
        "WEBSITE": "添加网站"
      },
      "placeholder": {
        "EMAIL": "邮箱地址",
        "PHONE": "电话号码",
        "SOCIAL": "社交账号",
        "WEBSITE": "网站地址"
      },
      "looksLike": {
        "EMAIL": "看起来是 {{count}} 个邮箱。",
        "PHONE": "看起来是 {{count}} 个电话号码。",
        "SOCIAL": "看起来是 {{count}} 个社交账号。",
        "WEBSITE": "看起来是 {{count}} 个网站。"
      },
      "error": {
        "platformRequired": "请选择平台，或粘贴个人主页链接。",
        "notAnEmail": "这看起来不像邮箱地址。",
        "notAWebsite": "这看起来不像网址。",
        "valueRequired": "请输入内容，或删除此行。"
      },
      "hint": {
        "phoneUnreadable": "无法校验此号码，将按输入保存。",
        "phoneIncomplete": "对于 +{{code}} 来说此号码偏短或偏长，将按输入保存。",
        "phoneTrunkZero": "国家代码后的开头 0 应省略。",
        "duplicate": "与第 {{row}} 行相同。"
      },
      "pasted": "粘贴时已添加国家代码。",
      "keepAsPasted": "按原样保留：{{value}}",
      "splitInto_other": "拆分为 {{count}} 行",
      "use": "使用 {{fix}}",
      "goOn": "继续",
      "primary": "主要",
      "countryFor": "{{row}}的国家",
      "platformFor": "{{row}}的平台",
      "labelFor": "{{row}}的标签",
      "label": "标签",
      "remove": "删除 {{what}}"
    },
    "location": {
      "placeholder": "输入或搜索地点"
    },
    "reference": {
      "select": "选择{{noun}}",
      "search": "搜索{{noun}}"
    },
    "list": {
      "manage": "管理{{title}}",
      "remove": "删除",
      "removeQuestion": "删除{{item}}？",
      "newItem": "新{{item}}",
      "copy": "复制 {{text}}",
      "moveUp": "上移 {{label}}",
      "moveDown": "下移 {{label}}",
      "moved": "已移动到位置 {{position}}/{{count}}。",
      "putBack": "已放回位置 {{position}}/{{count}}。",
      "pickedUp": "已拿起{{label}}。用上下方向键移动，按空格键放下，按 Esc 放回。",
      "removed": "已删除{{label}}。"
    },
    "unit": {
      "overriddenIn": "已在 {{workspaces}} 中覆盖",
      "inheritFromGlobal": "恢复全局值",
      "inheritLabel": "恢复{{title}}的全局值",
      "inheritFailed": "恢复全局值失败",
      "inherited": "继承自全局",
      "overridden": "此处已覆盖",
      "cancelEditing": "取消编辑{{title}}",
      "readOnly": "{{title}}为只读",
      "edit": "编辑{{title}}",
      "noValue": "未填写"
    },
    "validation": {
      "required": "{{label}}为必填项",
      "notANumber": "{{label}}必须是数字",
      "wholeNumber": "{{label}}必须是整数",
      "wholeInches": "{{label}}必须是整数英寸",
      "outOfRange": "{{label}}必须介于 {{min}} 和 {{max}} 之间",
      "invalidOption": "{{label}}的选项无效",
      "invalidProject": "{{label}}的项目无效",
      "invalidDate": "{{label}}不是有效日期",
      "invalidDateRange": "{{label}}不是有效的日期范围",
      "dateRangeOrder": "{{label}}：开始日期不能晚于结束日期",
      "invalidUrl": "请输入有效的网址",
      "invalidEmail": "请输入有效的电子邮箱",
      "tagsNotAllowed": "不允许创建新标签",
      "invalidAmount": "金额无效",
      "negativeAmount": "金额不能为负数",
      "noDecimals": "{{currency}} 金额不能有小数",
      "tooManyDecimals_other": "金额最多保留 {{count}} 位小数",
      "billingUnit": "计费单位必须是按天、按小时或固定",
      "invalidPercent": "{{label}}：请输入 0 到 100 之间的整数"
    },
    "readOnlyReason": {
      "noCapability": "您没有编辑此字段的权限",
      "noCapabilityResource": "您没有编辑此资源的权限",
      "otherWorkspace": "切换到此工作区以编辑其值",
      "archivedWorkspace": "此工作区已归档",
      "displayOnly": "只读视图",
      "lockedByType": "此字段已被资源类型锁定"
    },
    "badge": {
      "overriddenCount_other": "此处有 {{count}} 个字段使用自己的值，而非全局值",
      "inherited": "显示全局值。在此保存会为该工作区设置自己的值。",
      "overridden": "该工作区有自己的值；此处不使用全局值。",
      "newRow": "本次编辑中添加；随列表一起保存。"
    },
    "partRequired": {
      "name": {
        "firstName": "请输入名字。",
        "lastName": "请输入姓氏。"
      },
      "contactDetails": {
        "type": "请选择类型。",
        "value": "请输入值。"
      },
      "currency": {
        "currency": "请选择币种。"
      },
      "measurementLegacy": {
        "unit": "请选择单位。"
      },
      "tags": {
        "tagName": "请输入标签名称。"
      },
      "groups": {
        "groupName": "请输入分组名称。"
      }
    },
    "jump": {
      "title": "跳转到字段",
      "placeholder": "查找字段或值…",
      "empty": "没有匹配的字段或值",
      "readOnly": "只读"
    }
  },
  "OverflowTabs": {
    "showMore": "再显示 {{count}} 个",
    "pinned": "因已选中而显示在此"
  },
  "DiscussionThread": {
    "today": "今天",
    "yesterday": "昨天"
  }
}
